import OrderedList from '@tiptap/extension-ordered-list'

export default OrderedList.extend({
  addAttributes () {
    return {
      ...this.parent?.(),
      type: { default: 'ordered-list', rendered: false }
    }
  }
})